import { JSX } from "react";

import { TenantVendorRisk } from "@oneleet/api_client";
import { getReadableText } from "@oneleet/utils";

import { ChevronDownIcon, ChevronUpIcon, ChevronsUpIcon } from "lucide-react";

import { Badge } from "@oneleet/components";

const iconByRisk: Record<TenantVendorRisk, JSX.Element> = {
  [TenantVendorRisk.HIGH]: <ChevronsUpIcon />,
  [TenantVendorRisk.MEDIUM]: <ChevronUpIcon />,
  [TenantVendorRisk.LOW]: <ChevronDownIcon />,
};

const colorByRisk: Record<
  TenantVendorRisk,
  Parameters<typeof Badge>["0"]["color"]
> = {
  [TenantVendorRisk.HIGH]: "red",
  [TenantVendorRisk.MEDIUM]: "yellow",
  [TenantVendorRisk.LOW]: "green",
};

export function VendorRiskBadge({ risk }: { risk: TenantVendorRisk }) {
  return (
    <Badge
      label={`${getReadableText(risk)} risk`}
      color={colorByRisk[risk]}
      startIcon={iconByRisk[risk]}
    />
  );
}
